import {
  AccountBox as AccountBoxIcon,
  AttachMoney as AttachMoneyIcon,
  List as ListIcon,
  Description as DescriptionIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  Assignment as AssignmentIcon,
  FlightTakeoff as FlightTakeoffIcon,
  School as SchoolIcon,
  VerifiedUser as VerifiedUserIcon,
  EventNote as EventNoteIcon,
} from "@material-ui/icons";

import { locale } from "./settings";

// Pages
import Buying from "./pages/Orders/Buying";
import Selling from "./pages/Orders/Selling";
import Company from "./pages/Company/Company";
import Stores from "./pages/Company/Stores";
import Emails from "./pages/Company/Emails";
import Logs from "./pages/Users/Logs";
import Users from "./pages/Users/Users";

/**
 * Sets all routes used in dashboard. All routes comes with title, icon and the page's component.
 * Display parameter can be set as 'menu' for main left menu or 'avatar' for avatar's menu
 * All routes for dashboard should be set here, even if it won't be displayed in any menu
 */

const dashboardRoutes = [
  {
    path: "/account",
    label: locale.myAccount.menuTitle,
    icon: AccountBoxIcon,
    component: Buying,
    layout: "/dashboard",
    display: "avatar",
  },
  {
    menuGroup: "pedidos",
    label: "Pedidos",
    icon: DescriptionIcon,
    layout: "/dashboard",
    display: "menu",
    links: [
      {
        path: "/orders/buying",
        label: "Aquisição de Troco",
        component: Buying,
      },
      {
        path: "/orders/selling",
        label: "Recolhimento de Cédulas",
        component: Selling,
      },
    ],
  },
  {
    menuGroup: "empresa",
    label: "Empresa",
    icon: BusinessIcon,
    layout: "/dashboard",
    display: "menu",
    links: [
      {
        path: "/company",
        label: "Dados da empresa",
        component: Company,
      },
      {
        path: "/stores",
        label: "Listagem de Lojas",
        component: Stores,
      },
      {
        path: "/emails",
        label: "E-mails de alerta",
        component: Emails,
      },
    ],
  },
  {
    menuGroup: "usuarios",
    label: "Usuários",
    icon: PeopleIcon,
    layout: "/dashboard",
    display: "menu",
    links: [
      {
        path: "/users",
        label: "Lista de usuários",
        component: Users,
      },
      {
        path: "/logs",
        label: "Logs de Acesso",
        component: Logs,
      },
    ],
  },
];

export default dashboardRoutes;
